SessionView = require 'views/member/session-view'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'

module.exports = class MemberSessionsView extends View
  initialize: ->
    @listenTo @model, 'change:sessions', @frameDebounce @render

  events:
    'click .js-log-out-other': 'logOutOther'

  render: ->
    data = @model.toJSON()

    @$el.html(templates.fill('member_session_list', data))

    sessionSubviews = for session in data.sessions ? []
      @subview(SessionView, @model, session, session.id)

    @ensureSubviews(sessionSubviews, @$('.js-sessions'))

    @

  logOutOther: (e) ->
    Util.stop(e)
    @model.run 'logoutOtherSessions'
    @model.set "sessions", _.filter @model.get('sessions'), (session) => session.isCurrent
    @render()



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-sessions-view.coffee